/**
 * Pure helper for the Face Mapping admin UI: suggests a Dato speaker for each
 * face the headshot identification left unmapped, using who was talking while
 * that face was on screen.
 */

/**
 * Chains face_label → speaker_label (`speakerFaceMapping`, the backend's
 * temporal-overlap match) with speaker_label → Dato speakerId
 * (`voiceMappings`). Faces already identified by headshot are skipped, as are
 * speakers not in `knownSpeakerIds` (e.g. a voice mapping to a removed speaker).
 */
export function suggestSpeakersFromVoiceTiming(
  faceLabels: string[],
  speakerIdentifications: Record<string, string>,
  speakerFaceMapping: Record<string, string>,
  voiceMappings: Record<string, string>,
  knownSpeakerIds: Set<string>,
): Record<string, string> {
  const suggestions: Record<string, string> = {};
  for (const faceLabel of faceLabels) {
    if (speakerIdentifications[faceLabel]) continue;
    const speakerLabel = speakerFaceMapping[faceLabel];
    const speakerId = speakerLabel ? voiceMappings[speakerLabel] : undefined;
    if (speakerId && knownSpeakerIds.has(speakerId)) {
      suggestions[faceLabel] = speakerId;
    }
  }
  return suggestions;
}
